import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Assessment } from '../types';

const assessmentQuestions: Assessment[] = [
  {
    id: 1,
    question: "What's your biggest challenge in achieving financial freedom?",
    options: [
      "Lack of investment knowledge",
      "Debt management",
      "Creating passive income",
      "Understanding market trends"
    ]
  },
  {
    id: 2,
    question: "Which area of personal development interests you most?",
    options: [
      "Health and wellness",
      "Relationship mastery",
      "Financial independence",
      "Travel and lifestyle design"
    ]
  },
  // Add more questions as needed
];

export const AssessmentQuiz = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState<Record<number, string>>({});

  const handleAnswer = (answer: string) => {
    setAnswers({ ...answers, [currentQuestion]: answer });
    if (currentQuestion < assessmentQuestions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      // Calculate recommendation
      calculateRecommendation();
    }
  };

  const calculateRecommendation = () => {
    // Implement recommendation logic based on answers
    console.log('Calculating recommendation based on:', answers);
  };

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-gradient-to-r from-purple-900 to-indigo-900 rounded-2xl p-8 text-white"
      >
        <h2 className="text-3xl font-bold mb-6">Knowledge Assessment</h2>
        {currentQuestion < assessmentQuestions.length ? (
          <>
            <h3 className="text-xl mb-4">{assessmentQuestions[currentQuestion].question}</h3>
            <div className="space-y-4">
              {assessmentQuestions[currentQuestion].options.map((option, index) => (
                <button
                  key={index}
                  onClick={() => handleAnswer(option)}
                  className="w-full text-left p-4 rounded-lg bg-white/10 hover:bg-white/20 transition-colors"
                >
                  {option}
                </button>
              ))}
            </div>
          </>
        ) : (
          <div className="text-center">
            <h3 className="text-2xl mb-4">Assessment Complete!</h3>
            <p>We're analyzing your responses to provide personalized recommendations.</p>
          </div>
        )}
      </motion.div>
    </div>
  );
};